// extracted by mini-css-extract-plugin
module.exports = {"main":"BBPicture_main__20PSS","list":"BBPicture_list__3QUvc","firstItemBold":"BBPicture_firstItemBold__1J14S","link":"BBPicture_link__2u68o"};